import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { governanceQueryLinkerSchema } from './governance-query-linker-schema';

export const governanceQuerySchema = z.object({
  ...governanceQueryLinkerSchema.shape,

  jurisdiction: z.string().nullish(),
  registration_number: z.string().nullish(),
  registered_agent_name: z.string().nullish(),
  registered_agent_addresses: z.array(addressQuerySchema).nullish(),
  notes: z.string().nullish(),
  supporting_documentation: z.array(fileQuerySchema).nullish(),
});

export type GovernanceQuerySchema = z.infer<typeof governanceQuerySchema>;

export const governanceQueryAllSchema = paginatedResponseSchema(governanceQuerySchema);

export type GovernanceQueryAllSchema = z.infer<typeof governanceQueryAllSchema>;
